<template>
  <div class="content content--project-single">
    <OverlayLoader v-if="!$store.getters.projectLoaded"></OverlayLoader>
    <MyHeader :breadcrumbItems="
      [

        {
          name: section.name,
          path: `/${$route.params.companySlug}/projects`
        },
        {
          name: projectTab.value,
          path: `/${$route.params.companySlug}/projects?tab=${slugify(projectTab.value)}`
        },
        {
          name: project.name,
          path: `/${$route.params.companySlug}/projects/${project.idProject}`
        },
      ]"/>

    <header class="content-header d-lg-none">
      <h1>{{project.name}}</h1>
    </header>

    <div class="container main-content">
      <div class="hero--project">
        <span class="hero-tag">{{projectTab.value}}</span>
        <span class="hero-title">{{project.name}}</span>
      </div>

      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <div class="article-content" v-html="project.description">
          </div>
          <div class="section-people article-content" v-if="project.milestones">
            <h2>Milestones</h2>
            <p v-html="project.milestones"></p>
          </div>
          <div class="section-people article-content" v-if="project.mainBenefits">
            <h2>Main benefits</h2>
            <p v-html="project.mainBenefits"></p>
          </div>
          <div class="section-people article-content" v-if="project.capgeminiContact">
            <h2>Capgemini contact person</h2>
            <p v-html="project.capgeminiContact"></p>
          </div>
          <div class="section-people" v-if="project._embedded && project._embedded.TeamMembers">
            <h2>Capgemini project members</h2>
            <div class="row boxes-row">
              <div class="col-lg-4" v-for="(person,i) in project._embedded.TeamMembers" :key="i">
                <TeamMemberBox :box="person" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../../components/general/Header'
import OverlayLoader from "@/components/general/OverlayLoader";
import {slugify} from "@/helpers/slugify";
import settings from "@/settings";
import TeamMemberBox from "@/components/persons/TeamMemberBox";
export default {
  name: "ProjectSingle",
  components: {TeamMemberBox, OverlayLoader, MyHeader},
  mounted() {
    this.getProject();
  },
  watch: {
    '$store.getters.projectLoaded'(val) {
      if (val) {
        window._paq.push(['setDocumentTitle', this.project.name]);
        window._paq.push(['trackPageView']);
      }
    }
  },
  computed: {
    project() {
      return this.$store.getters.project
    },
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'Projects'
      })
    },
    projectTab() {
      if(this.project._embedded) {
        return this.$store.getters.settingsCompanyByCode(settings.SETTING_TYPES.PROJECTS_DOMAINS).find((item) => {
          return this.project._embedded.Content.idType === item.idSettingCompany
        })
      }
      return {}
    },
  },
  methods: {
    getProject() {
      this.$store.dispatch('getProject', {_embed: 1, idProject: this.$route.params.id})
    },
    slugify: slugify
  }
}
</script>
